import { AuthService } from 'src/app/core/services/auth.service';

export type EntitlementCheckFunction = (authService: AuthService) => boolean;

export interface CustomRouteData {
  entitlementUrl?: string | EntitlementCheckFunction;
}

export interface SecondaryNavItem extends CustomRouteData {
  routerLink: string;
  displayText: string;
  external?: boolean;
}

export interface ExternalNavItem extends CustomRouteData {
  text: string;
  url: string;
}

export function anyUrls(...entitlementUrls: string[]): EntitlementCheckFunction {
  return (authService) => entitlementUrls.some((url) => authService.isEntitled(url));
}

export function allUrls(...entitlementUrls: string[]): EntitlementCheckFunction {
  return (authService) => entitlementUrls.every((url) => authService.isEntitled(url));
}
